export type MobileOS = 'ios' | 'android' | 'other'

export function getMobileOS(): 'ios' | 'android' | 'other' {
    if (typeof navigator === 'undefined') return 'other'
    const userAgent = navigator.userAgent || ''
    if (/android/i.test(userAgent)) return 'android'
    if (
        /iPad|iPhone|iPod/.test(userAgent) ||
        (navigator.platform === 'MacIntel' && (navigator as any).maxTouchPoints > 1)
    )
        return 'ios'
    return 'other'
}
